import { Loader2 } from 'lucide-react';
import { FunctionComponent } from 'react';

interface iFullPageLoaderProps {
  title?: string;
  subtitle?: string;
}

const FullPageLoader: FunctionComponent<iFullPageLoaderProps> = ({ title, subtitle }) => {
  return (
    <div className='flex w-full h-full items-center justify-center bg-slate-50 dark:bg-stone-950'>
      <div className='flex flex-col items-center justify-center'>
        <Loader2 className='size-8 animate-spin' />
        <span className='font-semibold pt-4 text-slate-700 dark:text-white'>{title || 'Loading...'}</span>
        <span className='text-xs text-slate-500 font-medium dark:text-white/70'>{subtitle}</span>
      </div>
    </div>
  );
};

export default FullPageLoader;
